'use client';

import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { createSelectors } from '@m/utils/zustand/create-selectors';

type CustomerState = {
  clearCustomerId: () => void;
  customerId: string | null;
  setCustomerId: (customerId: string) => void;
};

const useCustomerStoreBase = create<CustomerState>()(
  persist(
    (set) => ({
      customerId: null,
      setCustomerId: (customerId: string) => set({ customerId }),
      clearCustomerId: () => set({ customerId: null }),
    }),
    {
      name: 'customer-store',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ customerId: state.customerId }),
    },
  ),
);

export const useCustomerStore = createSelectors(useCustomerStoreBase);

export function getCustomerId(): string | null {
  return useCustomerStore.getState().customerId;
}
